import { Civil3dFeatureType } from '../constants/civil3d-feature-type';
import { ArcgisCivil3dPropertyMappingApiModel } from './arcgis-civil3d-property-mapping.model';
import { ArcgisCivil3dSettingApiModel } from './arcgis-civil3d-setting.model';
import { PointLabelStyleApiModel } from './point-label-style.model';
import { PointStyleApiModel } from './point-style.model';

export type ArcgisCivil3dCogoPointSettingApiModel = ArcgisCivil3dSettingApiModel & {
  civil3dFeatureType: string;
  pointStyle: { id: number } | null;
  pointLabelStyle: { id: number } | null;
};

export type WithCivil3dFeatureType = ArcgisCivil3dCogoPointSettingApiModel & {
  civil3dFeatureType: Civil3dFeatureType;
};

export type WithPointStyle = ArcgisCivil3dCogoPointSettingApiModel & {
  pointStyle: PointStyleApiModel | null;
};

export type WithPointLabelStyle = ArcgisCivil3dCogoPointSettingApiModel & {
  pointLabelStyle: PointLabelStyleApiModel | null;
};

export type WithPropertyMappings = ArcgisCivil3dCogoPointSettingApiModel & {
  propertyMappings: ArcgisCivil3dPropertyMappingApiModel[];
};

export enum ArcgisCivil3dCogoPointSettingRelationship {
  CONFIGURATION = 'CONFIGURATION',
  ARCGIS_FEATURE_CLASS = 'ARCGIS_FEATURE_CLASS',
  POINT_STYLE = 'POINT_STYLE',
  POINT_LABEL_STYLE = 'POINT_LABEL_STYLE',
  AUTODESK_LAYER = 'AUTODESK_LAYER',
  PROPERTY_MAPPINGS = 'PROPERTY_MAPPINGS',
}
